import {
  GET_ATTACHMENT_TEMPLATES,
  GET_ATTACHMENT_TEMPLATE,
  GET_PAGINATED_ATTACHMENT_TEMPLATES,
  CREATE_ATTACHMENT_TEMPLATE,
  UPDATE_ATTACHMENT_TEMPLATE,
  DELETE_ATTACHMENT_TEMPLATES,
  GETTING_ATTACHMENT_TEMPLATES,
  GETTING_PAGINATED_ATTACHMENT_TEMPLATES,
  GETTING_PAGINATED_ATTACHMENT_TEMPLATES_SUCCEEDED,
  GETTING_PAGINATED_ATTACHMENT_TEMPLATES_FAILED,
  GETTING_MINIMAL_ATTACHMENT_TEMPLATES,
  GETTING_MINIMAL_ATTACHMENT_TEMPLATES_SUCCEEDED,
  GETTING_MINIMAL_ATTACHMENT_TEMPLATES_FAILED,
  GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS,
  GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS_SUCCEEDED,
  GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS_FAILED,
  GETTING_ATTACHMENT_TEMPLATE,
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE,
  CREATING_ATTACHMENT_TEMPLATE,
  UPDATING_ATTACHMENT_TEMPLATE,
  DELETING_ATTACHMENT_TEMPLATES,
  GETTING_ATTACHMENT_TEMPLATE_SUCCEEDED,
  CREATING_ATTACHMENT_TEMPLATE_SUCCEEDED,
  UPDATING_ATTACHMENT_TEMPLATE_SUCCEEDED,
  DELETING_ATTACHMENT_TEMPLATES_SUCCEEDED,
  GETTING_ATTACHMENT_TEMPLATES_SUCCEEDED,
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE_SUCCEEDED,
  GETTING_ATTACHMENT_TEMPLATES_FAILED,
  GETTING_ATTACHMENT_TEMPLATE_FAILED,
  CREATING_ATTACHMENT_TEMPLATE_FAILED,
  UPDATING_ATTACHMENT_TEMPLATE_FAILED,
  DELETING_ATTACHMENT_TEMPLATES_FAILED,
  SET_CURRENT_ATTACHMENT_TEMPLATE,
  UNSET_CURRENT_ATTACHMENT_TEMPLATE,
  SET_NEXT_STEP,
  UNSET_NEXT_STEP,
  CLEAR_ATTACHMENT_TEMPLATE_ERROR,
  CLEAR_ATTACHMENT_TEMPLATE_STORE,
  ATTACHMENT_AUTO_SAVE_TIMER_START,
  ATTACHMENT_AUTO_SAVE_TIMER_END,
  GET_ATTACHMENT_TAGS,
  GETTING_ATTACHMENT_TAGS,
  GETTING_ATTACHMENT_TAGS_SUCCEEDED,
  GETTING_ATTACHMENT_TAGS_FAILED,
  SET_COPY_CURRENT_ATTACHMENT_TEMPLATE,
  UPDATE_ATTACHMENT_FILTERS,
  RESET_ATTACHMENT_FILTERS,
  GET_ATTACHMENT_TEMPLATE_FILE,
  GETTING_ATTACHMENT_TEMPLATE_FILE_SUCCEEDED,
  GETTING_ATTACHMENT_TEMPLATE_FILE_FAILED,
  DOWNLOADED_ATTACHMENT_TEMPLATE_FILE,
  SET_ATTACHMENT_TEST_DOWNLOAD
} from './actions';
import { createReducer } from '@reduxjs/toolkit';
import starters from './data/templateStarters.json';
import { Base64 } from 'js-base64';
import sortBy from 'lodash.sortby';
import { ProductType } from 'constants.js';

const deCamelizer = str => {
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/([0-9]+)/g, ' $1')
    .replace(/^./, str => str.toUpperCase());
};

const initialState = {
  getting: false,
  gettingPaginated: true,
  gettingMinimal: false,
  creating: false,
  creatingPaginated: false,
  updating: false,
  deleting: false,
  deletingPaginated: false,
  list: [],
  paginatedList: [],
  minimalList: [],
  minimalTotalRecords: 0,
  selectedNamesByUuid: {},
  gettingNamesByUuids: false,
  current: {
    productType: ProductType.Product
  },
  starters,
  error: {
    message: null,
    raw: null
  },
  isTemplateSaved: false,
  isTestDownloadError: false,
  shouldAutoSave: false,
  isAutoSaveTimerRunning: false,
  isAutoSaveSuccess: false,
  isTemplateSaving: false,
  isInTemplateDesignDialog: false,
  filters: {
    searchInput: '',
    displayActive: true,
    sortBy: 'name',
    sortOrder: 'ASC',
    rowsPerPage: 10,
    pageNo: 0,
    totalCount: 0,
    filterTypes: [],
    filterTemplates: [],
    filterProductNames: [],
    filterProductCategories: [],
    filterMarketingTypes: [],
    filterTags: [],
    filterStatus: []
  },
  tagList: [],
  gettingTags: false,
  // Test attachment template state (matches print template pattern)
  attachmentFile: {
    getting: false,
    gettingFileSucceeded: false,
    attachmentFileBlob: {},
    isDownloading: false
  }
};

const types = {
  PNG: 'PNG',
  DOC: 'DOC',
  PDF: 'PDF'
};

const parsePageLayout = template => {
  let pageLayoutRegex = /<body.*?>{{#each\s+(.*)\s*}}<div.*?>/;
  let matchedPageLayout = (template.jsonContent?.html || '').match(pageLayoutRegex);
  let pageLayout = matchedPageLayout ? matchedPageLayout[1] : null;
  return pageLayout;
}

export default createReducer(initialState, {
  [GET_ATTACHMENT_TEMPLATES]: state => {
    return state;
  },
  [GET_PAGINATED_ATTACHMENT_TEMPLATES]: state => {
    return state;
  },
  [GET_ATTACHMENT_TEMPLATE]: state => {
    return state;
  },

  [CREATE_ATTACHMENT_TEMPLATE]: state => {
    state.isTemplateSaved = false;
    state.isTemplateSaving = true;
    return state;
  },
  [UPDATE_ATTACHMENT_TEMPLATE]: state => {
    state.isTemplateSaved = false;
    state.isTemplateSaving = true;
    return state;
  },
  [DELETE_ATTACHMENT_TEMPLATES]: (state, action) => {
    return state;
  },
  [GETTING_ATTACHMENT_TEMPLATES]: state => {
    state.getting = true;
    return state;
  },
  [GETTING_PAGINATED_ATTACHMENT_TEMPLATES]: state => {
    state.gettingPaginated = true;
    return state;
  },
  [GETTING_MINIMAL_ATTACHMENT_TEMPLATES]: state => {
    state.gettingMinimal = true;
    return state;
  },
  [GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS]: state => {
    state.gettingNamesByUuids = true;
    return state;
  },
  [GETTING_ATTACHMENT_TEMPLATE]: state => {
    state.getting = true;
    return state;
  },
  [GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE]: state => {
    state.getting = true;
    return state;
  },
  [CREATING_ATTACHMENT_TEMPLATE]: state => {
    state.creating = true;
    state.current = {
      ...state.current,
      active: state.current.active === undefined ? true : state.current.active
    };
    return state;
  },
  [UPDATING_ATTACHMENT_TEMPLATE]: state => {
    state.updating = true;
    return state;
  },
  [DELETING_ATTACHMENT_TEMPLATES]: state => {
    state.deleting = true;
    return state;
  },
  [GETTING_ATTACHMENT_TEMPLATE_SUCCEEDED]: (state, action) => {
    const { template, eventMetaData = [] } = action.payload;
    let pageLayout;
    if(template.id) {
      pageLayout = parsePageLayout(template);
    }

    let hydratedEventMetaData = sortBy(
      eventMetaData.map(data => ({
        ...data,
        productName: data.schemaType === 'EVENT'
          ? `Event Product - ${template.productName}`
          : data.schemaType === 'ENRICHMENT' ? `Enrichment Product - ${data.enrichmentProduct}` : data.schemaTypeDisplayName,
        schemaConditionAttributes: data.schemaConditionAttributes.map(a => ({
          key: a.conditionAttribute,
          name:
            !a.displayName || a.displayName === ''
              ? deCamelizer(a.conditionAttribute)
              : a.displayName,
          dataType: a.conditionAttributeType,
          text: `{{${a.conditionAttribute}}}`,
          attributeFieldType: a.attributeFieldType,
          hasNestedDataFrame: a.hasNestedDataFrame,
          metaAttribute: a.metaAttribute,
          description: a.description,
          subAttribute: {
            ...a?.subAttribute,
            attributes:
              a?.subAttribute?.attributes &&
              a.subAttribute['attributes'].map(b => ({
                key: b.conditionAttribute,
                name:
                  !b.displayName || b.displayName === ''
                    ? deCamelizer(b.conditionAttribute)
                    : b.displayName,
                dataType: b.conditionAttributeType,
                text: `{{${b.conditionAttribute}}}`,
                metaAttribute: b.metaAttribute,
                description: b.description
              }))
          }
        }))
      })).filter(data => template.campaignOccurrenceType === 'INTERNAL_SURVEY_RESPONSE' || template.campaignOccurrenceType === 'EXTERNAL_SURVEY_RESPONSE' || template.productType === 'LIST' ? (data.schemaType === 'EVENT' || data.schemaType === 'ENRICHMENT' || data.schemaType === 'LIST') : data ),
      'name'
    );

    let updatedTemplate = {
      ...template,
      eventMetaData: hydratedEventMetaData
    };

    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { 
      ...updatedTemplate,
      ...(pageLayout && { pageIterator: pageLayout })
    };
    return state;
  },
  [CREATING_ATTACHMENT_TEMPLATE_SUCCEEDED]: (state, action) => {
    let pageLayout = parsePageLayout(action.payload);
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { 
      ...action.payload,
      ...(pageLayout && { pageIterator: pageLayout })
    };
    state.isAutoSaveSuccess = state.shouldAutoSave ? true : false;
    state.isTemplateSaved = true;
    state.shouldAutoSave = false;
    state.isTemplateSaving = false;
    return state;
  },
  [UPDATING_ATTACHMENT_TEMPLATE_SUCCEEDED]: (state, action) => {
    let pageLayout = parsePageLayout(action.payload);
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { 
      ...action.payload,
      ...(pageLayout && { pageIterator: pageLayout })
    };
    state.isAutoSaveSuccess = state.shouldAutoSave ? true : false;
    state.isTemplateSaved = true;
    state.shouldAutoSave = false;
    state.isTemplateSaving = false;
    return state;
  },
  [DELETING_ATTACHMENT_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.deletingPaginated = false;
    state.current = action.payload.find(uuid => uuid === state.current.uuid)
      ? {}
      : state.current;
    state.paginatedList = state.paginatedList.map(template => {
      if (template.uuid === action.payload[0]) {
        template.active = !template.active;
      }
      return template;
    });
    return state;
  },
  [GETTING_ATTACHMENT_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.list = action.payload.map(template => ({
      ...template,
      displayType: types[template.type]
    }));
    return state;
  },
  [GETTING_PAGINATED_ATTACHMENT_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = action.payload.map(template => {
      let pageLayout = parsePageLayout(template);
      return {
        ...template,
        displayType: types[template.type],
        ...(pageLayout && { pageIterator: pageLayout })
      }
    });
    const namesByUuidFromPage = (action.payload || []).reduce((result, template) => {
      if (template?.uuid && template?.name) {
        result[template.uuid] = template.name;
      }
      return result;
    }, {});
    state.selectedNamesByUuid = {
      ...state.selectedNamesByUuid,
      ...namesByUuidFromPage
    };
    return state;
  },
  [GETTING_MINIMAL_ATTACHMENT_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.gettingMinimal = false;
    state.minimalList = action.payload.data || [];
    state.minimalTotalRecords = action.payload.totalRecords || 0;
    return state;
  },
  [GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS_SUCCEEDED]: (state, action) => {
    state.gettingNamesByUuids = false;
    state.selectedNamesByUuid = {
      ...state.selectedNamesByUuid,
      ...(action.payload || {})
    };
    return state;
  },
  [GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE_SUCCEEDED]: (
    state,
    action
  ) => {
    state.current = {
      ...state.current,
      associatedCampaigns: action.payload.campaignList.find(
        campaign => campaign.uuid === state.current?.uuid
      )
    };
    state.paginatedList = state.paginatedList.map(template => {
      if (template.uuid === action.payload.uuid) {
        template.associatedCampaigns = action.payload.campaignList;
      }
      return template;
    });
    return state;
  },
  [GETTING_ATTACHMENT_TEMPLATES_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_PAGINATED_ATTACHMENT_TEMPLATES_FAILED]: (state, action) => {
    state.gettingPaginated = false;
    state.creatingPaginated = false;
    state.deletingPaginated = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_MINIMAL_ATTACHMENT_TEMPLATES_FAILED]: (state, action) => {
    state.gettingMinimal = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS_FAILED]: (state, action) => {
    state.gettingNamesByUuids = false;
    state.error = {
      message: action.payload?.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_ATTACHMENT_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [CREATING_ATTACHMENT_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.isTemplateSaved = false;
    state.shouldAutoSave = false;
    state.isAutoSaveSuccess = false;
    state.isTemplateSaving = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [UPDATING_ATTACHMENT_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.isTemplateSaved = false;
    state.shouldAutoSave = false;
    state.isAutoSaveSuccess = false;
    state.isTemplateSaving = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [DELETING_ATTACHMENT_TEMPLATES_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },

  [SET_CURRENT_ATTACHMENT_TEMPLATE]: (state, action) => {
    state.current = {
      ...action.payload,
      jsonContent: !action.payload.jsonContent
        ? JSON.parse(Base64.decode(starters[0].data))
        : action.payload.jsonContent
    };
    return state;
  },
  [UNSET_CURRENT_ATTACHMENT_TEMPLATE]: state => {
    state.current = { ...initialState.current };
    return state;
  },
  [CLEAR_ATTACHMENT_TEMPLATE_ERROR]: state => {
    state.error = { ...initialState.error };
    return state;
  },
  [CLEAR_ATTACHMENT_TEMPLATE_STORE]: state => {
    let updatedState = {
      ...initialState,
    };
    return updatedState;
  },

  [ATTACHMENT_AUTO_SAVE_TIMER_START]: state => {
    state.shouldAutoSave = false;
    state.isAutoSaveSuccess = false;
    state.isAutoSaveTimerRunning = true;
    return state;
  },
  [ATTACHMENT_AUTO_SAVE_TIMER_END]: state => {
    state.shouldAutoSave = true;
    state.isAutoSaveTimerRunning = false;
    return state;
  },
  [SET_NEXT_STEP]: state => {
    state.isInTemplateDesignDialog = true;
    return state;
  },
  [UNSET_NEXT_STEP]: state => {
    state.isInTemplateDesignDialog = false;
    return state;
  },
  [GET_ATTACHMENT_TAGS]: state => {
    state.error = {};
    return state;
  },

  [GETTING_ATTACHMENT_TAGS]: state => {
    state.gettingTags = true;
    return state;
  },

  [GETTING_ATTACHMENT_TAGS_SUCCEEDED]: (state, action) => {
    state.gettingTags = false;
    state.tagList = action.payload;
    return state;
  },

  [GETTING_ATTACHMENT_TAGS_FAILED]: (state, action) => {
    state.gettingTags = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },

  [SET_COPY_CURRENT_ATTACHMENT_TEMPLATE]: (state, action) => {
    state.current = action.payload;
    return state;
  },

  [UPDATE_ATTACHMENT_FILTERS]: (state, action) => {
    state.gettingPaginated = true;
    state.filters = {
      ...state.filters,
      ...action.payload
    };
    return state;
  },
  
  [RESET_ATTACHMENT_FILTERS]: state => {
    state.gettingPaginated = true;
    state.filters = { ...initialState.filters };
    return state;
  },

  [GET_ATTACHMENT_TEMPLATE_FILE]: (state) => {
    state.attachmentFile = {
      getting: true,
      isDownloading: true,
      gettingFileSucceeded: false,
      attachmentFileBlob: {}
    };
    state.isTestDownloadError = false;
    return state;
  },

  [GETTING_ATTACHMENT_TEMPLATE_FILE_SUCCEEDED]: (state, action) => {
    state.attachmentFile = {
      getting: false,
      gettingFileSucceeded: true,
      attachmentFileBlob: action.payload
    };
    state.isTestDownloadError = false;
    return state;
  },

  [GETTING_ATTACHMENT_TEMPLATE_FILE_FAILED]: state => {
    state.attachmentFile = {
      getting: false,
      gettingFileSucceeded: false,
      attachmentFileBlob: {}
    };
    state.isTestDownloadError = true;
    return state;
  },

  [DOWNLOADED_ATTACHMENT_TEMPLATE_FILE]: state => {
    state.attachmentFile = {
      ...state.attachmentFile,
      isDownloading: false,
      gettingFileSucceeded: false,
      attachmentFileBlob: {}
    };
    return state;
  },

  [SET_ATTACHMENT_TEST_DOWNLOAD]: (state, action) => {
    state.isTestDownloadError = action.payload;
    return state;
  }
});
